import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import { selectIsPermissionsExtendedEnabled } from '../../../../../../../pages/call/selectors';
import { PermissionsExtended } from './permissions-extended';
import { PermissionsStandard } from './permissions-standard';

export const PermissionsSection: FunctionComponent = () => {
    const isPermissionsExtendedEnabled = useSelector(selectIsPermissionsExtendedEnabled);

    if (isPermissionsExtendedEnabled) {
        return <PermissionsExtended />;
    }

    return <PermissionsStandard />;
};
